// extracted by mini-css-extract-plugin
export var _form = "forms-module--_form--2sBw7";